import * as yup from 'yup';

import { OperationFields } from '../../../../../operationsTypes';

import { formsErrors } from '../../../../../../../locales/keys';

export const createOperationFormSchema = yup.object().shape({
  [OperationFields.COMPLETE_DATETIME]: yup
    .date()
    .nullable()
    .required(formsErrors.required),
  [OperationFields.DATE]: yup
    .date()
    .nullable()
    .required(formsErrors.required)
    .min(
      yup.ref(OperationFields.COMPLETE_DATETIME),
      formsErrors.toDate.laterThanFrom
    )
});
